/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { Maybe, Nothing } from '@codegrade/maybe';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function toMaxNDecimals(num, n) {
    if (num == null) {
        return null;
    }
    let str = num.toFixed(n);
    if (n === 0) {
        return str;
    }
    while (str[str.length - 1] === '0') {
        str = str.slice(0, -1);
    }
    if (str[str.length - 1] === '.') {
        str = str.slice(0, -1);
    }
    return str;
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function maybeParseOrKeepFloat(num) {
    if (typeof num === 'number') {
        return Maybe.of(num);
    }
    else if (num == null) {
        return Nothing;
    }
    // We need to parse with both parseFloat and Number because:
    // * parseFloat('5a') -> 5  while  Number('5a') -> NaN
    // * parseFloat('') -> NaN  while  Number('') -> 0
    const fromParseFloat = parseFloat(num);
    const fromNumber = Number(num);
    if (fromParseFloat === fromNumber) {
        return Maybe.of(fromParseFloat);
    }
    else {
        return Nothing;
    }
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function parseOrKeepFloat(num) {
    return maybeParseOrKeepFloat(num).orDefault(NaN);
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function numberToTimes(number) {
    if (typeof number !== 'number') {
        throw new Error('The given argument should be a number');
    }
    if (number === 1) {
        return 'once';
    }
    else if (number === 2) {
        return 'twice';
    }
    else {
        return `${number} times`;
    }
}
// Divide a by b, or return dfl if b == 0.
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function safeDivide(a, b, dfl) {
    return b === 0 ? dfl : a / b;
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function getOrdinalSuffix(i) {
    const endsWith = i % 10;
    const mod100 = i % 100;
    const isTeen = mod100 >= 10 && mod100 < 20;
    if (endsWith === 1 && !isTeen) {
        return 'st';
    }
    if (endsWith === 2 && !isTeen) {
        return 'nd';
    }
    if (endsWith === 3 && !isTeen) {
        return 'rd';
    }
    return 'th';
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function withOrdinalSuffix(i) {
    return `${i}${getOrdinalSuffix(i)}`;
}
